import {ApiExecDecrypted, downloadFile} from "../../utils/ApiExec";

class MapService {
  getSections = (params) => {
    return ApiExecDecrypted(params, "map/cartography/get-sections", "POST")
      .then((res) => res)
      .then((res) => res)
      .catch((error) => error);
  };
  getBlocks = (params) => {
    return ApiExecDecrypted(params, "map/cartography/get-blocks", "POST")
      .then((res) => res)
      .then((res) => res)
      .catch((error) => error);
  };
  getFederalDistricts = (params) => {
    return ApiExecDecrypted(params, "map/cartography/get-dfeds", "POST")
      .then((res) => res)
      .then((res) => res)
      .catch((error) => error);
  };
  getShapes = (params) => {
    return ApiExecDecrypted(params, "map/cartography/get-shapes", "POST")
      .then((res) => res)
      .then((res) => res)
      .catch((error) => error);
  }
  downloadShapeCartography  = (params) => {
    return downloadFile({
      api: "map/cartography/get-shape-cartography",
      method: "POST",
      data: params,
    })
      .then((res) => res)
      .catch((e) => e);
  };
}
var map = new MapService();
export default map;
